import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export interface UsuarioExistente {
  id: string
  nome: string
  email: string
  igreja: {
    id: string
    nome: string
  }
}

export function useVerificarEmail(email: string) {
  return useQuery({
    queryKey: ['verificar-email', email],
    queryFn: async (): Promise<UsuarioExistente | null> => {
      if (!email || email.length < 3 || !supabase) {
        return null
      }

      // Usar maybeSingle() em vez de single() para evitar erro quando não encontra
      const { data, error } = await supabase
        .from('usuarios')
        .select(`
          id,
          nome,
          email,
          igreja:igrejas(
            id,
            nome
          )
        `)
        .eq('email', email.toLowerCase())
        .maybeSingle() // Esta função não gera erro quando não encontra registros

      if (error) {
        // Se houver erro real (não relacionado a "não encontrado"), lançar
        throw error
      }

      // Se data é null, significa que o email não existe (disponível para uso)
      // Se data existe, significa que o email já está cadastrado
      return data as UsuarioExistente | null
    },
    enabled: !!email && email.length >= 3,
    staleTime: 1000 * 60 * 5, // 5 minutos
    retry: false,
    // Configurações para suprimir logs de erro
    meta: {
      errorPolicy: 'silent'
    }
  })
}